import React from 'react'
import * as styles from './style'

export interface Props {
  children: React.ReactNode | React.ReactNode[]
  padding?: string
}

const EmptyBlock = ({ children, padding }: Props): JSX.Element => (
  <div style={{ padding }} className={styles.root}>
    {children}
  </div>
)
export default EmptyBlock
